import { Localizer } from '../utils/localize.js';

export const enGb = {
    code: 'en-gb',
    name: 'English',
    dir: 'ltr',

    welcome: 'Welcome',
    'wj.file.upload.button': 'Browse files',
    'wj.file.upload.uploaded': 'Uploaded: ',
    'wj.file.upload.from': 'from',
    'wj.stepper.button.next': 'Next',
    'wj.stepper.button.finish': 'Finish',
    'wj.stepper.button.previous': 'Previous',
    'wj.stepper.step': 'Step',
    'wj.pagination.of': 'of',
    'wj.pagination.first': 'First page',
    'wj.pagination.prev': 'Previous',
    'wj.pagination.next': 'Next',
    'wj.pagination.last': 'Last page',
};

Localizer.registerTranslation(enGb);
